import React, { useState } from 'react';
import CallPhones from './CallPhones';
import CallKpis from './CallKpis';

/**
 * La sección de Llamadas, partida en dos como Kapso y Resend:
 * **Configuración** (los números) y **KPIs** (qué está pasando con ellos).
 *
 * Van separadas porque se usan en momentos distintos: la configuración se toca
 * al dar de alta un cliente y casi nunca más; los KPIs se miran cada semana.
 * Mezclarlas obligaría a bajar por una tabla de números para llegar a lo que se
 * consulta a diario.
 */

const TABS = [
  { key: 'config', label: 'Números' },
  { key: 'kpis', label: 'KPIs' },
];

const CallsSettings = () => {
  const [tab, setTab] = useState('config');

  return (
    <div className='space-y-4'>
      <div className='flex gap-1 rounded-lg border border-slate-200 bg-white p-1'>
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            type='button'
            onClick={(e) => {
              setTab(key);
              e.target.blur();
            }}
            className={`rounded-lg px-4 py-2 text-sm font-medium outline-none transition-colors focus:outline-none ${
              tab === key ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'config' ? <CallPhones /> : <CallKpis />}
    </div>
  );
};

export default CallsSettings;
